var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105.632,
    height: 27.375,
    viewBox: "0 0 105.632 27.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 105.631,
    height: 27.375,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M0,0V27.375H105.632V0Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241-2",
    "data-name": "Group 241",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M266.9,22.183h11.569a.5.5,0,0,0,.5-.5v-.359a.5.5,0,0,0-.5-.5H266.9a.5.5,0,0,0-.5.5v.359a.5.5,0,0,0,.5.5",
    transform: "translate(-180.564 -14.118)",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M285.453,38.718a.263.263,0,0,0-.136-.488h-3.873a.509.509,0,0,0-.433.245c-.238.392-.394.65-.518.851a.5.5,0,0,0,.425.759c1.66,0,2.907-.012,4.192-.082a.5.5,0,0,0,.305-.864.263.263,0,0,1,.039-.422",
    transform: "translate(-190.064 -25.912)",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M79.546,0H0V27.374H105.631V0ZM26.086,26.086H1.289V1.289h24.8Zm26.086,0h-24.8V1.289h24.8Zm26.086,0H53.46V1.289h24.8Zm22.117-14.265a.5.5,0,0,1-.5.5H98.055a.5.5,0,0,0-.352.849c.98.983,1.388,1.406,1.765,1.858a.5.5,0,0,1-.085.713l-.752.566a.5.5,0,0,1-.7-.1c-.121-.164-.255-.339-.418-.541a.5.5,0,0,0-.441-.185c-.816.087-1.92.161-2.808.214a.5.5,0,0,0-.466.5v.563a.5.5,0,0,0,.5.5h4.786a.5.5,0,0,1,.5.5v.591a.5.5,0,0,1-.5.5H94.3a.5.5,0,0,0-.5.5v.842a.5.5,0,0,0,.5.5h5.579a.5.5,0,0,1,.5.5v.649a.5.5,0,0,1-.5.5H86.333a.5.5,0,0,1-.5-.5v-.649a.5.5,0,0,1,.5-.5h4.979a.5.5,0,0,0,.5-.5V19.33a.5.5,0,0,0-.5-.5H87.184a.5.5,0,0,1-.5-.5v-.591a.5.5,0,0,1,.5-.5h4.129a.5.5,0,0,0,.5-.5v-.433a.5.5,0,0,0-.522-.5c-2.748.1-3.744.136-4.253.156a.5.5,0,0,1-.51-.423l-.12-.8a.5.5,0,0,1,.494-.57c.224,0,.47,0,.663.008A.5.5,0,0,0,88,13.938c.246-.412.388-.659.509-.909a.5.5,0,0,0-.449-.711H86.333a.5.5,0,0,0-.5.5v.431c0,4.427-.452,6.543-1.763,8.873a.5.5,0,0,1-.758.137l-.942-.8a.5.5,0,0,1-.114-.616c1.509-2.854,1.509-4.77,1.509-7.649V5.759a.5.5,0,0,1,.5-.5h15.61a.5.5,0,0,1,.5.5v3.3a.5.5,0,0,1-.5.5H86.333a.5.5,0,0,0-.5.5v.127a.5.5,0,0,0,.5.5H99.877a.5.5,0,0,1,.5.5Z",
    transform: "translate(0 0)",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M17.078,32.326l1.111.447a.545.545,0,0,0,.689-.257,35.5,35.5,0,0,0,3.109-9.979.548.548,0,0,1,.532-.448l1.967-.016c1.721-.019,2.281.909,2.281,2.9a21.441,21.441,0,0,1-.561,4.62c-.348,1.179-.947,1.508-2.185,1.508a11.933,11.933,0,0,1-1.941-.162.543.543,0,0,0-.63.569l.051.917a.545.545,0,0,0,.479.511,22.235,22.235,0,0,0,2.466.177,3.468,3.468,0,0,0,3.441-1.933,16.624,16.624,0,0,0,1.005-5.741c0-1.914-.251-5.394-4.137-5.394H23.043a.546.546,0,0,1-.54-.62c.141-1.033.223-1.676.284-2.239a.545.545,0,0,0-.505-.6L21.14,16.5a.545.545,0,0,0-.581.5c-.062.764-.14,1.577-.264,2.559a.547.547,0,0,1-.542.48H17.492a.546.546,0,0,0-.545.545V21.6a.546.546,0,0,0,.553.545l1.739-.023a.545.545,0,0,1,.543.647,30.071,30.071,0,0,1-2.98,8.784.548.548,0,0,0,.278.774",
    transform: "translate(-11.34 -11.185)",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M57.722,29.789a.545.545,0,0,0,.624.475l1.179-.181a.548.548,0,0,0,.458-.609c-.574-4.691-1.814-6.039-2.806-7.015a.545.545,0,0,0-.672-.072l-.751.472a.544.544,0,0,0-.124.817c.7.81,1.634,2.188,2.091,6.114",
    transform: "translate(-37.616 -15.116)",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M107.145,27.986c2.681-.191,3.413-6.694,4.459-7.433,1.475-1.041,3.019.484,3.019,4.64,0,5.566-4.209,5.985-8.4,6.062a.479.479,0,0,0-.46.572l.217,1.094a.483.483,0,0,0,.479.387c7.787-.126,10.366-2.833,10.366-8.25,0-4.5-2.511-7.141-5.065-6.708-1.938.329-3.025,3.769-4,6.34-.122.321-.773,1.553-1.317.72-.527-.808.449-6.041.915-8.082a.478.478,0,0,0-.435-.583l-1.253-.087a.481.481,0,0,0-.506.386,44.753,44.753,0,0,0-.729,8.613,2.333,2.333,0,0,0,2.709,2.329",
    transform: "translate(-70.778 -11.29)",
    fill: "#f36a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M177.221,20.115c3.612-.294,13.83-1.049,13.953-.207.136.934-2.182.408-6.814,2.3a6.058,6.058,0,0,0-4,5.618,5.267,5.267,0,0,0,2.88,4.524c1.694.875,3.676,1.356,7.533,1.407a.51.51,0,0,0,.511-.442l.17-1.264a.508.508,0,0,0-.509-.577c-5.217.083-8.362-.989-8.362-3.822,0-2.61,2.218-3.612,3.438-4.033a31.529,31.529,0,0,1,5.028-1.257c3.085-.54,3.069-2.043,3.087-2.379,0,0,.254-1.43-1.542-2.029-2.542-.847-12.118-.329-15.5-.043a.507.507,0,0,0-.464.525l.042,1.188a.507.507,0,0,0,.548.49",
    transform: "translate(-119.719 -11.856)",
    fill: "#f36a10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9d6756a5048302faf0ac163acab9d10d.svg";
export { ForwardRef as ReactComponent };